import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSupportCenterGlyphSecondary from './svgs/SupportCenterGlyphSecondary.js';
import SvgSupportCenterGlyph from './svgs/SupportCenterGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var supportCenterGlyph = (props => useIcon(SvgSupportCenterGlyph, SvgSupportCenterGlyphSecondary, props));

export { supportCenterGlyph as default };
